"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterCommunicationService = void 0;
var rxjs_1 = require("rxjs");
var cash_dom_1 = __importDefault(require("cash-dom"));
var InterCommunicationService = /** @class */ (function () {
    function InterCommunicationService() {
        this.events = [];
        this.$moduleChannel = new rxjs_1.ReplaySubject(1);
        this.eventName = 'fittec-event';
        this.bootstrappedModules = {};
        this.parentSubscriptions = {};
    }
    /**
     * Sends internal and external events through the app
     * @param event
     */
    InterCommunicationService.prototype.sendEvent = function (event) {
        var _this = this;
        var _a;
        this.events.push(event);
        this.$moduleChannel.next(event);
        var renderedEvent = new CustomEvent(this.eventName, {
            detail: event,
            bubbles: true,
        });
        if (event.event === 'loaded') {
            this.bootstrappedModules[event.module.uid] = event.value.instance;
        }
        if (event.event === 'globalCustom') {
            (0, cash_dom_1.default)()
                .parents('[data-uid]')
                .each(function (index, ele) {
                var _a;
                //using om tree traverse parents up to send events to the parents
                var uid = ele.getAttribute('data-uid');
                if (uid && ((_a = _this.parentSubscriptions) === null || _a === void 0 ? void 0 : _a[uid])) {
                    _this.parentSubscriptions[uid].next(event);
                }
            });
            (_a = document.body) === null || _a === void 0 ? void 0 : _a.dispatchEvent(renderedEvent);
        }
        else {
            event.module.$container.parents('[data-uid]').each(function (index, ele) {
                var _a;
                //using om tree traverse parents up to send events to the parents
                var uid = ele.getAttribute('data-uid');
                if (uid && ((_a = _this.parentSubscriptions) === null || _a === void 0 ? void 0 : _a[uid])) {
                    _this.parentSubscriptions[uid].next(event);
                }
            });
            event.module.$container.get(0).dispatchEvent(renderedEvent);
        }
    };
    InterCommunicationService.prototype.subscribeChildren = function (module) {
        if (!module.uid) {
            console.error('no module uid found ', module);
            return new rxjs_1.ReplaySubject(1);
        }
        //Create a replaysubject for parent modules that are interested in getting child events
        if (!this.parentSubscriptions[module.uid]) {
            this.parentSubscriptions[module.uid] = new rxjs_1.ReplaySubject(1);
        }
        return this.parentSubscriptions[module.uid];
    };
    InterCommunicationService.prototype.subscribeGlobally = function () {
        return this.$moduleChannel;
    };
    InterCommunicationService.prototype.getHistory = function () {
        return this.events;
    };
    return InterCommunicationService;
}());
exports.InterCommunicationService = InterCommunicationService;
